import { Typography } from "@mui/material";
import type { FC } from "react";
import { CalculatorResultAmount } from "web_myplann/Calculators/Components/CalculatorResultAmount";
import { RefinancingOutcome } from "web_myplann/Calculators/Types/RefinancingOutcome";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { formatRate } from "web_myplann/Shared/Utils/percentageFormatters";

type Props = {
	saving: number;
	rate: number;
	outcome: RefinancingOutcome;
};

export const RefinancingResultHero: FC<Props> = ({ saving, rate, outcome }) => {
	const { t } = useResource();

	if (outcome === RefinancingOutcome.Saving) {
		return (
			<CalculatorResultAmount
				amount={saving}
				meta={t(Resources.Calculators.Result.NewRateMeta, {
					unit: t(Resources.Calculators.Result.Unit),
					rate: formatRate(rate),
				})}
			/>
		);
	}

	return (
		<Typography variant="bodyStrong">
			{t(
				outcome === RefinancingOutcome.Better
					? Resources.Calculators.Refinancing.ResultBetterThanPartners
					: Resources.Calculators.Refinancing.ResultSameAsPartners,
			)}
		</Typography>
	);
};
